import React, { useRef } from "react";
import "flatpickr/dist/themes/light.css";

import Flatpickr from "react-flatpickr";
import { Input } from "reactstrap"; // Import Input from reactstrap

interface DatePickerFilterProps {
  dateValue?: Date;
  handleChange: (date: Date | undefined) => void;
  maxDate?: any;
  minDate?: any;
}

const DatePickerFilter = ({
  handleChange,
  dateValue,
  maxDate,
  minDate,
}: DatePickerFilterProps) => {
  const fp = useRef(null);

  return (
    <div className="flatpickr-wrapper">
      <Flatpickr
        value={dateValue}
        maxDate={maxDate}
        minDate={minDate}
        onChange={([date]) => {
          if (date == undefined) {
            handleChange(undefined)
          } else {
            const adjustedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() + 4);
            handleChange(adjustedDate);
          }
        }}
        options={{
          minDate: minDate,
          maxDate: maxDate,
          locale: {
            firstDayOfWeek: 1,
          },
          time_24hr: false,
          enableTime: false,
        }}
      />

    </div>
  );
};

export default DatePickerFilter;
